import { CartItem, CartItemPayload } from '../storage/cart.types'

export const productToCartPayload = (product: CartItem): CartItemPayload => {
  return {
    productId: product.productId,
    quantity: product.quantity,
    unitPrice: product.basePriceExcGst,
    lineId: product.lineId ?? null,
  }
}
